module.exports = __webpack_public_path__ + "static/media/hu.823492d7.svg";